export interface NavItem {
  label: string;
  path: string;
}

export const SITE_NAME = '爆料大赛';

export const SITE_TAGLINE = '赛程时间表与活动安排，比赛进度随时查';

export const SITE_EMAIL = 'contact@baoliao-dasai.example.com';

export const NAV_ITEMS: NavItem[] = [
  { label: '首页', path: '/' },
  { label: '赛程时间表', path: '/schedule' },
  { label: '活动安排', path: '/arrangement' },
  { label: '常见问题', path: '/faq' },
  { label: '关于我们', path: '/about' },
];

export const SITE_STATS: { label: string; value: string; note: string }[] = [
  { label: '参赛作品', value: '1286', note: '件' },
  { label: '覆盖赛区', value: '32', note: '个' },
  { label: '评审团成员', value: '48', note: '位' },
  { label: '累计投票', value: '76.4', note: '万' },
];

export const CONTENT_PRINCIPLES: { title: string; text: string }[] = [
  { title: '时间为准', text: '所有阶段起止时间以赛程时间表页公布为准，临时调整会同步更新并标注变更说明。' },
  { title: '口径统一', text: '截稿、开投、出结果三类节点统一用同一套时间口径，避免各渠道说法不一致。' },
  { title: '过程透明', text: '每一次投票开始、名单公布与结果公示都留下记录，方便随时回查。' },
  { title: '不递补造谣', text: '只发布与赛事本身相关的信息，不为任何未经证实的消息背书。' },
];